import styled from 'styled-components';

import {
  colorBlack,
  colorGrey100,
  colorGrey400,
  colorWhite,
} from '@/styleUtils';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  font: 12px/16px Noto Sans, sans-serif;
  color: ${colorGrey400};
`;

export const Header = styled.header`
  display: flex;
  align-items: center;
  width: 100%;
  margin: 0 auto;
  padding: 0 16px;
  height: 56px;
  box-sizing: border-box;
  box-shadow: inset 0 -1px 0 ${colorGrey100};
  justify-content: center;
  ${({ $isHidden }) => ($isHidden ? 'display: none;' : 'display: flex;')}
`;
export const HeaderContentWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  max-width: ${({ $isVisible }) => ($isVisible ? '1100px' : '100%')};
`;
export const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
`;
export const PhoneWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Main = styled.main`
  flex: 1;
  color: ${colorBlack};
  justify-content: center;
  display: flex;
`;

export const Footer = styled.footer`
  position: relative;
  padding: 32px 0;
  background: ${colorWhite};
  box-shadow: 0 -1px 0 ${colorGrey100};
  text-align: center;
  line-height: 20px;
  ${({ $isHidden }) => ($isHidden ? 'display: none;' : 'display: flex;')}
  justify-content: center;
`;
